import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadFeatures,
  loadFeaturesError,
  loadFeaturesSuccess,
} from '../actions/features.actions';
import { UsersService } from '@fc-core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Feature } from '@fc-core/feature-flags/feature.model';

@Injectable()
export class FeaturesEffects {
  loadFeatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFeatures),
      switchMap(() => {
        return this.usersService.getFeatures().pipe(
          map((res: Feature[]) => {
            return loadFeaturesSuccess({
              payload: res.map((feature) => feature.key),
            });
          }),
          catchError((err) => of(loadFeaturesError(err))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private usersService: UsersService,
  ) {}
}
